<div class="card p-3 w-100">
    <div class="
        d-flex gap-2
        flex-column align-items-stretch justify-content-start
        flex-md-row align-items-md-center justify-content-md-between">
        <div class="d-flex flex-column align-items-start">
            <h4 class="ranking-name">My Ranking</h4>
            <h5 class="ranking-summary">2 Tables, 49 Entries</h5>
        </div>
        <div class="d-flex flex-row gap-2">
            <button class="btn-edit-ranking btn btn-secondary">
                <i class="bi bi-pencil"></i>
            </button>
            <button class="btn-delete-ranking btn btn-danger">
                <i class="bi bi-trash"></i>
            </button>
            <button class="btn-make-ranking-active btn btn-primary">
                Make active
            </button>
        </div>
    </div>
</div>